import React, { useRef, useState } from 'react';
//@ts-ignore
import * as styles from './customer-testimonial.module.css';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import ShowMoreArrow from '../Global/ShowMoreArrow';
import RichText from '../Global/RichText';
import SvgDownArrowSm from '../Global/ShowMoreArrow/SvgDownArrowSm';

interface Props {
    noOfCardsToDisplayOnMobile?: number;
    modifiedProducts?: any;
    revealMoreText?: string;
    testimonialLink?: string;
    testimonialCopy?: string;
    textColor?: string | any;
    backgroundColorr?: string | any;
    ctaTarget?: string;
    textColorEven?: string | any;
    backgroundColorrEven?: string | any;
    controlMargin?: any;
}

export const CustomerTestimonialCardsStackView: React.FC<Props> = ({
    noOfCardsToDisplayOnMobile,
    modifiedProducts,
    revealMoreText,
    testimonialLink,
    testimonialCopy,
    backgroundColorr,
    textColor,
    ctaTarget,
    textColorEven,
    backgroundColorrEven,
    controlMargin,
}) => {
    const wrapperRef = useRef(null);
    const breakpoints = useBreakpoint();
    const [showAll, setShowAll] = useState(
        noOfCardsToDisplayOnMobile && !breakpoints.sm ? false : true
    );
    const toggleShowAll = () => {
        setShowAll((prevShowAll) => !prevShowAll);
    };

    return (
        <>
            <style>{`
        @media screen and (max-width: 580px){
        .even-slide {
            background-color: ${backgroundColorrEven} !important;
            color:${textColorEven} !important;
             svg polyline {
             stroke: ${textColorEven} !important;
            }
             a:hover{
            svg polyline {
             stroke: #f06623 !important;
            }}
            margin: 0rem;
          }
    
          .odd-slide {
            background-color: ${backgroundColorr} !important;
            color:${textColor} !important;
            svg polyline {
             stroke: ${textColor} !important;
            }
            a:hover{
            svg polyline {
             stroke: #f06623 !important;
            }}
          }
        }
        `}</style>
            <div
                className={styles.wrapper}
                ref={wrapperRef}
                style={controlMargin ? { marginBottom: '0px' } : {}}
            >
                {modifiedProducts.value.length &&
                    modifiedProducts.value
                        .slice(
                            0,
                            breakpoints.sm || (showAll && !breakpoints.sm)
                                ? modifiedProducts.value.length
                                : noOfCardsToDisplayOnMobile
                        )
                        .map((card, idx) => {
                            const slideClass =
                                idx % 2 === 0 ? 'odd-slide' : 'even-slide';
                            return (
                                <div className={styles.cardWrapper} key={idx}>
                                    <div
                                        className={`${styles.card} ${slideClass}`}
                                        style={{
                                            backgroundColor:
                                                backgroundColorr || 'lightGrey',
                                            color: textColor || '#262525',
                                        }}
                                    >
                                        {card.testimonialCopy && (
                                            <p
                                                className={
                                                    styles.testimonialCopy
                                                }
                                                data-kontent-element-codename="testimonial_copy"
                                            >
                                                {card.testimonialCopy}
                                            </p>
                                        )}
                                        {card.productName && (
                                            <p
                                                className={styles.name}
                                                data-kontent-element-codename="testimonial_name"
                                            >
                                                {card.productName}
                                            </p>
                                        )}
                                        {testimonialLink && testimonialCopy && (
                                            <div>
                                                <p>
                                                    <a
                                                        target={ctaTarget}
                                                        href={testimonialLink}
                                                        rel={
                                                            ctaTarget ===
                                                            '_blank'
                                                                ? 'noopener noreferrer'
                                                                : undefined
                                                        }
                                                        className={styles.cta}
                                                    >
                                                        {testimonialCopy || ''}

                                                        <p
                                                            style={{
                                                                width: '11px',
                                                            }}
                                                            className={
                                                                styles.ctaArrow
                                                            }
                                                        >
                                                            <SvgDownArrowSm
                                                                strokeColor={
                                                                    textColor ||
                                                                    '#262525'
                                                                }
                                                                strokeWidth={3}
                                                            />
                                                        </p>
                                                    </a>
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                {noOfCardsToDisplayOnMobile &&
                    modifiedProducts.value.length >
                        noOfCardsToDisplayOnMobile &&
                    !breakpoints.sm && (
                        <>
                            {showAll ? (
                                <div className={styles.showLessArrow}>
                                    <ShowMoreArrow
                                        btnText={''}
                                        strokeColor={'#505251'}
                                        handleClick={() => {
                                            toggleShowAll();
                                            if (wrapperRef.current) {
                                                wrapperRef.current.scrollIntoView(
                                                    {
                                                        behavior: 'instant',
                                                    }
                                                );
                                            }
                                        }}
                                        transform={'0'}
                                        customStyles={
                                            controlMargin
                                                ? { marginBottom: '0px' }
                                                : {}
                                        }
                                    />
                                </div>
                            ) : (
                                <ShowMoreArrow
                                    btnText={revealMoreText || ''}
                                    strokeColor={'#505251'}
                                    handleClick={toggleShowAll}
                                    transform={'0'}
                                    customStyles={
                                        controlMargin
                                            ? { marginBottom: '0px' }
                                            : {}
                                    }
                                />
                            )}
                        </>
                    )}
            </div>
        </>
    );
};
